<template>
  <div class="p-3">
    <div
      class="bg-gray mb-4 p-3"
      :key="index"
      v-for="(item, index) in orderDetail?.documents"
    >
      <div class="row m-0 d-flex align-items-center">
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 ">
            Tipo de Documento:
          </div>
          <div class="color-black font-16">
            {{ item.documentTypeName | empty }}
          </div>
        </div>
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 ">
            Archivo:
          </div>
          <div class="color-black font-16">
            {{ item.fileName | empty }}
          </div>
        </div>
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 ">
            Fecha:
          </div>
          <div class="color-black font-16">
            {{ item.date | date }}
          </div>
        </div>
        <div
          class="col-md-2 col-12 d-flex align-items-center justify-content-end"
        >
          <button
            class="btn btn-success pt-1 mr-2"
            @click="handleDownloadFile(item)"
          >
            <i class="fas fa-file-download" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//services
import documentsService from '@/services/documents';

export default {
  name: 'DocumentsInfo',
  components: {},
  props: {
    orderDetail: {
      type: Object,
    },
  },
  methods: {
    async handleDownloadFile(document) {
      if (document.documentId) {
        documentsService.downloadFromServer(document.documentId);
      }
    },
  },
};
</script>
<style></style>
